import { Card, Col, Row, InputGroup, Form, Button } from 'react-bootstrap';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/es';
import { flexRender, getCoreRowModel } from '@tanstack/react-table';
import { useReactTable } from '@tanstack/react-table';
import { getPaginationRowModel } from '@tanstack/react-table';
import { getFilteredRowModel } from '@tanstack/react-table';
import Flex from '../../../../../components/common/Flex';
import { formatPhoneNumber } from '../..';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight } from 'react-icons/fa';

// Activamos el soporte para formatos personalizados
dayjs.extend(customParseFormat);
dayjs.locale('es');

const formatFecha = (fechaStr) => {
    if (!fechaStr || typeof fechaStr !== 'string') return ' ';
    const fecha = new Date(fechaStr);
    const offset = new Date().getTimezoneOffset() * 60000; // Obtener offset en milisegundos
    const fecha_inicio = new Date(fecha.getTime() - offset).toISOString();
    try {
        return dayjs(fecha_inicio, 'YYYY/MM/DD/ HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
    } catch (error) {
        console.error('Error al formatear la fecha:', error);
        return 'N/A';
    }
};

const MasterTableConsumos = ({ data = [], perPage = 10, title = "", counterButton = null }) => {

    const safeTableData = Array.isArray(data) ? data : [];
    const style2Lines = {
        display: "-webkit-box",
        WebkitLineClamp: 2, // Limita a 2 líneas
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "normal",
    };
    // Personalizar la vista del Select
    const customStyles = {
        minWidth: '70px',
        minHeight: '30px',
        maxHeight: '30px',
        fontSize: '12px',
        overflow: 'hidden',
        appearance: 'none',
        WebkitAppearance: 'none',
        MozAppearance: 'none',
        backgroundColor: 'white',
        border: '1px solid #ccc',
        paddingRight: '20px',
        paddingLeft: '10px',
        backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' fill='lightgrey' viewBox='0 0 24 24'><path d='M12 15.41 6.41 9.83 7.83 8.41 12 12.59 16.17 8.41 17.59 9.83z'/></svg>")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 5px center',
        backgroundSize: '25px',
    };

    // Estructura de columnas 
    const columns = [
        {
            accessorKey: 'id', header: 'Alerta', cell: ({ row: { original } }) => (
                <Flex> {/* Ajustar ancho máximo del contenedor */}
                    <span
                        style={style2Lines}
                        title={original.nombrealerta} // Mostrar tooltip con el texto completo
                    >
                        {original.nombrealerta}
                    </span>
                </Flex>
            )
        },
        {
            accessorKey: 'vehiculo', header: 'Vehículo', cell: ({ row: { original } }) => (
                <Flex> {/* Ajustar ancho máximo del contenedor */}
                    <span
                        style={style2Lines}
                        title={original.vehiculo} // Mostrar tooltip con el texto completo
                    >
                        {original.vehiculo}
                    </span>
                </Flex>
            )
        },
        {
            accessorKey: 'fechaHoraEvento', header: 'Fecha', cell: ({ row: { original } }) => (
                <Flex> {/* Ajustar ancho máximo del contenedor */}
                    <span
                        style={style2Lines}
                        title={formatFecha(original.fechaHoraEvento)} // Mostrar tooltip con el texto completo
                    >
                        {formatFecha(original.fechaHoraEvento)}
                    </span>
                </Flex>
            )
        },
        {
            accessorKey: 'destinatario', header: 'Destinatario', cell: ({ row: { original } }) => (
                <Flex> {/* Ajustar ancho máximo del contenedor */}
                    <span
                        style={style2Lines}
                        title={formatPhoneNumber(original.destino)} // Mostrar tooltip con el texto completo
                    >
                        {original.destinatario}
                    </span>
                </Flex>
            )
        },
        {
            accessorKey: 'mensaje',
            header: 'Mensaje',
            cell: ({ row: { original } }) => (
                <Flex> {/* Ajustar ancho máximo del contenedor */}
                    <h6
                        style={style2Lines}
                        title={original.mensaje} // Mostrar tooltip con el texto completo
                    >
                        {original.mensaje}
                    </h6>
                </Flex>
            ),
        },
        {
            accessorKey: 'consumo',
            header: 'Consumo',
            cell: ({ row: { original } }) => {
                var consumo = '';
                switch (original.consumo) {
                    case 'sms':
                        consumo = 'Mensaje SMS';
                        break;
                    case 'email':
                        consumo = 'Mensaje Email';
                        break;
                    case 'whatsapp':
                        consumo = 'Mensaje de Whatsapp';
                        break;
                    case 'voz':
                        consumo = 'Mensaje de voz';
                        break;
                }
                return (
                    <Flex> {/* Ajustar ancho máximo del contenedor */}
                        <h6
                            style={style2Lines}
                            title={consumo} // Mostrar tooltip con el texto completo
                        >
                            {consumo}
                        </h6>
                    </Flex>
                );
            },
        },
    ];

    const table = useReactTable({
        data: safeTableData,
        columns,
        sortable: true,
        pagination: true,
        perPage,
        getPaginationRowModel: getPaginationRowModel(),
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getSubRows: (row) => row.children,
        enableColumnFilters: false,
        initialState: {
            pagination: {
                pageSize: perPage,
            },
        },
    });

    const Filter = function ({ column, table }) {
        const firstValue = table
            .getPreFilteredRowModel()
            .flatRows[0]?.getValue(column.id)
        const columnFilterValue = column.getFilterValue()

        return typeof firstValue === "number" ? (
            <div className="flex space-x-2">
                <input
                    type="number"
                    value={columnFilterValue?.[0] ?? ""}
                    onChange={e => column.setFilterValue(old => [e.target.value, old?.[1]])}
                    placeholder={`Min`}
                    className="w-24 border shadow rounded"
                />
            </div>
        ) : (
            <input
                type="text"
                value={columnFilterValue ?? ""}
                onChange={e => column.setFilterValue(e.target.value)}
                placeholder={`Search...`}
                className="w-36 border shadow rounded"
            />
        )
    }

    return (
        <Card className="h-100" >
            <Card.Header className='pt-0' >
                <Row className="d-flex align-items-center justify-content-between">

                    <Col md={6}>
                        <h6 className="mb-0 text-nowrap py-2 py-xl-0">{title}</h6>
                    </Col>

                    <Col md={4} className="d-flex justify-content-end align-items-center pe-0">
                        <div className="d-flex align-items-center h-100">
                            {counterButton}
                        </div>
                    </Col>

                    <Col md={2}>
                        <Form className='d-flex p-2 flex-row-reverse'>
                            <Form.Select
                                className='p-2'
                                size="sm"
                                style={{ width: '100px' }}
                                value={table.getState().pagination.pageSize}
                                onChange={e => {
                                    table.setPageSize(Number(e.target.value))
                                }}
                            >
                                {[5, 10, 20, 30, 40, 50].map(pageSize => (
                                    <option key={pageSize} value={pageSize}>
                                        {pageSize}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form>
                    </Col>
                </Row>
            </Card.Header>
            <Card.Body className="p-0">


                <div style={{ minHeight: "440px", maxHeight: "440px", overflow: "auto" }}>
                    <table className='fs-10 mb-0 overflow-hidden table table-striped table-bordered'>
                        <thead className='text-nowrap align-middle'>
                            {table.getHeaderGroups().map(headerGroup => (
                                <tr key={headerGroup.id}>
                                    {headerGroup.headers.map(header => {
                                        return (
                                            <th key={header.id} colSpan={header.colSpan}>
                                                {header.isPlaceholder ? null : (
                                                    <div>
                                                        {flexRender(
                                                            header.column.columnDef.header,
                                                            header.getContext()
                                                        )}
                                                    </div>
                                                )}
                                            </th>
                                        )
                                    })}
                                </tr>
                            ))}
                        </thead>
                        <tbody>
                            {table.getRowModel().rows.map(row => {
                                return (
                                    <tr key={row.id}>
                                        {row.getVisibleCells().map(cell => {
                                            return (
                                                <td key={cell.id}>
                                                    {flexRender(
                                                        cell.column.columnDef.cell,
                                                        cell.getContext()
                                                    )}
                                                </td>
                                            )
                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>


            </Card.Body>

            <Card.Footer className="bg-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div className="d-flex align-items-center">
                        <span className="me-2">
                            Total: {table.getFilteredRowModel().rows.length} | Página {table.getState().pagination.pageIndex + 1} de {table.getPageCount()}
                        </span>
                        <Form.Control
                            type="number"
                            min="1"
                            max={table.getPageCount()}
                            value={table.getState().pagination.pageIndex + 1}
                            onChange={e => {
                                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                table.setPageIndex(page);
                            }}
                            style={{ width: '70px', height: '31px' }}
                            size="sm"
                        />
                    </div>
                    <div className="d-flex justify-content-center">
                        <Button
                            variant="outline-dark"
                            size="sm"
                            className="mx-1"
                            onClick={() => table.setPageIndex(0)}
                            disabled={!table.getCanPreviousPage()}
                        >
                            <FaAngleDoubleLeft />
                        </Button>
                        <Button
                            variant="outline-dark"
                            size="sm"
                            className="mx-1"
                            onClick={() => table.previousPage()}
                            disabled={!table.getCanPreviousPage()}
                        >
                            <FaAngleLeft />
                        </Button>

                        {(() => {
                            let pagesArray = [];
                            if (table.getPageCount() <= 5) {
                                pagesArray = Array.from({ length: table.getPageCount() }, (_, i) => i);
                            } else if (table.getState().pagination.pageIndex <= 2) {
                                pagesArray = [0, 1, 2, 3, 4];
                            } else if (table.getState().pagination.pageIndex >= table.getPageCount() - 3) {
                                pagesArray = [
                                    table.getPageCount() - 5,
                                    table.getPageCount() - 4,
                                    table.getPageCount() - 3,
                                    table.getPageCount() - 2,
                                    table.getPageCount() - 1
                                ];
                            } else {
                                pagesArray = [
                                    table.getState().pagination.pageIndex - 2,
                                    table.getState().pagination.pageIndex - 1,
                                    table.getState().pagination.pageIndex,
                                    table.getState().pagination.pageIndex + 1,
                                    table.getState().pagination.pageIndex + 2
                                ];
                            }

                            return pagesArray.map(pageNum => (
                                <Button
                                    key={`page-${pageNum}`}
                                    variant={pageNum === table.getState().pagination.pageIndex ? "primary" : "outline-dark"}
                                    size="sm"
                                    className="mx-1"
                                    onClick={() => table.setPageIndex(pageNum)}
                                >
                                    {pageNum + 1}
                                </Button>
                            ));
                        })()}

                        <Button
                            variant="outline-dark"
                            size="sm"
                            className="mx-1"
                            onClick={() => table.nextPage()}
                            disabled={!table.getCanNextPage()}
                        >
                            <FaAngleRight />
                        </Button>
                        <Button
                            variant="outline-dark"
                            size="sm"
                            className="mx-1"
                            onClick={() => table.setPageIndex(table.getPageCount() - 1)}
                            disabled={!table.getCanNextPage()}
                        >
                            <FaAngleDoubleRight />
                        </Button>
                    </div>
                </div>
            </Card.Footer>
        </Card>
    );


    return (
        <Col className="h-100">
            <div style={{ minHeight: "380px", maxHeight: "380px", overflow: "auto" }}>
                <>
                    <table
                        className='fs-10 mb-0 overflow-hidden table table-striped table-bordered'
                    >
                        <thead className='text-nowrap align-middle'>
                            {table.getHeaderGroups().map(headerGroup => (
                                <tr key={headerGroup.id}>
                                    {headerGroup.headers.map(header => {
                                        return (
                                            <th key={header.id} colSpan={header.colSpan}>
                                                {header.isPlaceholder ? null : (
                                                    <div>
                                                        {flexRender(
                                                            header.column.columnDef.header,
                                                            header.getContext()
                                                        )}

                                                        {header.column.getCanFilter() ? (
                                                            <div>
                                                                <Filter column={header.column} table={table} />
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                )}
                                            </th>
                                        )
                                    })}
                                </tr>
                            ))}
                        </thead>
                        <tbody>
                            {table.getRowModel().rows.map(row => {
                                return (
                                    <tr key={row.id}>
                                        {row.getVisibleCells().map(cell => {
                                            return (
                                                <td key={cell.id}>
                                                    {flexRender(
                                                        cell.column.columnDef.cell,
                                                        cell.getContext()
                                                    )}
                                                </td>
                                            )
                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </>
            </div>

            <>
                <div>

                    <Row className='justify-content-center'>
                        <Col className='flex-grow-1 mt-2'>
                            <div className='d-flex align-items-center fs-10'>

                                <p className='mb-0'>

                                    <span className="d-sm-inline-block me-2">
                                        <strong>
                                            {table.getState().pagination.pageIndex + 1} - {' '}
                                            {table.getPageCount()} de {data.length}
                                        </strong>
                                    </span>
                                </p>


                                <p className="mb-0 mx-2">Página: </p>

                                <span className="flex items-center gap-1">
                                    <input
                                        type="number"
                                        min="1"
                                        max={table.getPageCount()}
                                        value={table.getState().pagination.pageIndex + 1}
                                        onChange={e => {
                                            const page = e.target.value ? Number(e.target.value) - 1 : 0
                                            table.setPageIndex(page)
                                        }}
                                        className="border p-1 rounded w-16"
                                    />
                                </span>

                                <p className="mb-0 mx-2">Paginado: </p>
                                <select
                                    style={customStyles}
                                    value={table.getState().pagination.pageSize}
                                    onChange={e => {
                                        table.setPageSize(Number(e.target.value))
                                    }}
                                >
                                    {[5, 10, 20, 30, 40, 50].map(pageSize => (
                                        <option key={pageSize} value={pageSize}>
                                            {pageSize}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </Col>
                        <Col className='flex-grow-0 mt-2 align-items-center' >
                            <Row className='px-3 flex-nowrap justify-content-end'>
                                <button
                                    className="border rounded ms-2 btn outline-dark btn-sm"
                                    style={{ minWidth: '60px', maxWidth: '60px' }}
                                    onClick={() => table.setPageIndex(0)}
                                    disabled={!table.getCanPreviousPage()}
                                >
                                    {<FaAngleDoubleLeft></FaAngleDoubleLeft>}
                                </button>

                                <button
                                    className="border rounded ms-2 btn outline-dark btn-sm"
                                    style={{ minWidth: '60px', maxWidth: '60px' }}
                                    onClick={() => table.previousPage()}
                                    disabled={!table.getCanPreviousPage()}
                                >
                                    {<FaAngleLeft></FaAngleLeft>}
                                </button>
                                <button
                                    className="border rounded ms-2 btn outline-dark btn-sm"
                                    style={{ minWidth: '60px', maxWidth: '60px' }}
                                    onClick={() => table.nextPage()}
                                    disabled={!table.getCanNextPage()}
                                >
                                    {<FaAngleRight></FaAngleRight>}
                                </button>
                                <button
                                    className="border rounded ms-2 btn outline-dark btn-sm"
                                    style={{ minWidth: '60px', maxWidth: '60px' }}
                                    onClick={() => table.setPageIndex(table.getPageCount() - 1)}
                                    disabled={!table.getCanNextPage()}
                                >
                                    {<FaAngleDoubleRight></FaAngleDoubleRight>}
                                </button>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </>
        </Col>
    );
};

export default MasterTableConsumos;